import React, {Component} from 'react';
import {Redirect} from "react-router-dom";
import $ from 'jquery';

import android from './img/VocMiner_microsite_button_Android.png';
import apple from './img/VocMiner_microsite_button_Apple.png';
import {translate} from "react-i18next";


class LearningPage extends Component {


    handleCenterVertically = () => {
        let $learningPage = $('.learningPage');
        let windowHeight = $(window).height();
        let minerBarHeight = $('.minerBar').height();
        let top = (windowHeight / 2) - ($learningPage.height()) + minerBarHeight;
        $learningPage.css('top', top.toString()+'px');
        $learningPage.css('width', $('.pageSection').width().toString()+ 'px');
    };

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleCenterVertically);
    }

    componentWillMount() {
        // this.handleCenterVertically();
    }

    componentDidMount() {
        this.handleCenterVertically();
        window.addEventListener("resize", this.handleCenterVertically);
    }


    render() {

        if (this.state && this.state.redirect) {
            return (<Redirect push to={this.state.redirect}/>);
        }
        return (
            <div className="learningPage" style={{textAlign: 'center', position: 'absolute'}}>
                <p style={{marginBottom: '30px'}}>{this.props.t('learning_available_in_mobile_apps_only')}</p>
                <a href={process.env.REACT_APP_ANDROID_APP_URL} style={{marginRight: '20px'}}><img alt={"Android Play"} height={70} src={android}/></a>
                <a href={process.env.REACT_APP_IPHONE_APP_URL} ><img alt={"Apple Store"} height={70} src={apple} /></a>
            </div>
        );
    }
}

export default translate()(LearningPage)




// WEBPACK FOOTER //
// ./src/components/learning/LearningPage.js